<div *ngIf="mdsGroup" class="ac-modal modal-wrapper">
	<div class="header">
		<icon type="times" class="btn close-icon pull-right" (click)="closeDialog()"></icon>
		<h3 class="text-align-center">{{ mdsGroup.name }}</h3>
	</div>
	<div class="content">
		<div>
			<div class="text-16-bold padding-bottom-5" dcrHTMLKey="MDS_GROUP_DESCRIPTION_TITLE">Description</div>
			<div class="text-14" [dcrHTMLKey]="'MDS_GROUP_DESCRIPTION_' + mdsGroup.groupId | uppercase">
				<span> MDS_GROUP_DESCRIPTION_ + {{ mdsGroup.groupId }}</span>
			</div>
		</div>
		<bfa-tabs type="underline" [showTabNavSeparator]="true">
			<ng-container class="tab-content" *ngFor="let scenario of mdsGroup.scenarios; index as tabIndex">
				<ng-template #table>
					<dcr-cell-content [config]="scenario.name"></dcr-cell-content>
					<ng-container>
						<div class="mds-scenario-description" [dcrHTMLKey]="'MDS_SCENARIO_DESCRIPTION_' + scenario.id | uppercase">
							<span>MDS_SCENARIO_DESCRIPTION_ + {{ scenario.id }}</span>
						</div>
						<div class="padding-top-25">
							<span class="text-16-bold" dcrHTMLKey="CALIBRATION_DETAILS_TITLE">Calibration Details</span>
							<section class="table-title-separator"></section>
							<div class="calibration-table" [dcrHTMLKey]="'MDS_SCENARIO_CALIBRATION_TABLE_' + scenario.id | uppercase">
								<span>MDS_SCENARIO_CALIBRATION_TABLE_ + {{ scenario.id }}</span>
							</div>
							<div class="calibration-disclaimer text-14 padding-top-25" [dcrHTMLKey]="'MDS_SCENARIO_CALIBRATION_DISCLAIMER_' + scenario.id | uppercase">
								<span>MDS_SCENARIO_CALIBRATION_DISCLAIMER_ + {{ scenario.id }}</span>
							</div>
						</div>
					</ng-container>
				</ng-template>
				<tab-panel [tab-title]="scenario.name" [templateRef]="table"></tab-panel>
			</ng-container>
		</bfa-tabs>
	</div>
</div>
